export default {
  AGREE_ANNOUNCEMENT_BUTTON: 'AGREE_ANNOUNCEMENT_BUTTON',
  DISAGREE_ANNOUNCEMENT_BUTTON: 'DISAGREE_ANNOUNCEMENT_BUTTON',
  EXIT_BUTTON: 'EXIT_BUTTON',
  READ_AGAIN_BUTTON: 'READ_AGAIN_BUTTON',

  ANNOUNCEMENT_TITLE: 'ANNOUNCEMENT_TITLE',

  DISAGREE_ANNOUNCEMENT_TIPS: 'DISAGREE_ANNOUNCEMENT_TIPS',

  GET_ANNOUNCEMENT_ERROR: 'GET_ANNOUNCEMENT_ERROR',
  NETWORK_ERROR: 'NETWORK_ERROR',
}